



import { defineAsyncComponent, defineComponent } from '@nuxtjs/composition-api';
import { gql } from 'graphql-tag';

import { contentableBlockColorFragment } from '@/composables/block-color';

import { largeImageFragment } from '@/graphql/queries/image.fragments';

export default defineComponent({
  components: {
    Page: defineAsyncComponent(() => import('@/pages/news/_slug.vue')),
  },
  graphqlData: gql`
    fragment NewsArticleContentData on NewsArticleContent {
      id
      title
      lead
      publishedAt
      parentPageUrl
      image {
        ...LargeImageData,
      }
      blocks {
        __typename @inject
      }
      ...ContentableBlockColor
    }

    ${largeImageFragment}
    ${contentableBlockColorFragment}
  `,
});
